"use client";

import React from "react";
import styles from "./HostingReliabilitySection.module.css";
import { hostingReliabilityData as data } from "../../data/hosting";

export default function HostingReliabilitySection() {
  const { title, subTitle, metrics, features, eyebrow } = data;

  return (
    <section className={`py-5 ${styles.section}`}>
      <div className="container">
        <div className={`row g-4 align-items-start`}>
          <div className="col-12 col-lg-5" data-reveal="fade">
            <div className={styles.header}>
              <span className={styles.eyebrow}>{eyebrow}</span>
              <h2 className={styles.title}>{title}</h2>
              <p className={styles.sub}>{subTitle}</p>
              <div className={styles.metrics}>
                {metrics.map((m) => (
                  <div key={m.label} className={styles.metricBadge}>
                    <span className={styles.metricLabel}>{m.label}</span>
                    <span className={styles.metricValue}>{m.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-7" data-reveal="stagger-up">
            <div className={styles.grid}>
              {features.map((f) => (
                <div key={f.title} className={styles.tile}>
                  <div className={styles.tileIcon} aria-hidden>
                    <i className={f.icon} />
                  </div>
                  <h5 className={styles.tileTitle}>{f.title}</h5>
                  <p className={styles.tileText}>{f.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
